import React from 'react';
import { FaPlus } from 'react-icons/fa';
import '../styles/Mails.css';

const AdminMails = () => {
  const mails = ['Service Inquiry','Partnership Request','Quote Request','Customer Feedback'];
  return (
    <div className="mails-page">
      <h1>Mails</h1>
      <p>View and manage email communications.</p>
      <button className="compose-btn"><FaPlus /> Compose Email</button>
      <table className="mails-table">
        <thead><tr><th>#</th><th>Subject</th><th>From</th><th>Date</th><th>Actions</th></tr></thead>
        <tbody>{mails.map((subject,i)=>(<tr key={i}><td>{i+1}</td><td>{subject}</td><td>client@email.com</td><td>April {12-i}, 2026</td><td><button className="view-btn">View</button></td></tr>))}</tbody>
      </table>
    </div>
  );
};
export default AdminMails;
